<template>
  <div class="flex flex-col items-start gap-2">
    <div class="flex flex-row gap-2">
      <BlueIconButton @click="moveToHome(uuid)">
        <WhiteHouseIcon />
      </BlueIconButton>

      <slot />
    </div>

    <MoveAxisRow :uuid="uuid" axis="X" />
    <MoveAxisRow :uuid="uuid" axis="Y" />
    <MoveAxisRow :uuid="uuid" axis="Z" />
  </div>
</template>

<script setup>

import MoveAxisRow from "@/components/molecules/MoveAxisRow.vue";
import {defineProps} from "vue";
import BlueIconButton from "@/components/molecules/BlueIconButton.vue";
import WhiteHouseIcon from "@/components/atoms/WhiteHouseIcon.vue";
import xhr from "@/utils/xhr";
import {jsonValidator} from "@/utils/JsonValidator";
import {t} from "@/utils/Traduction";
import {NotificationStores} from "@/stores/NotificationStores";

defineProps({
  uuid: {
    type: String,
    required: true,
  },
});

const notificationStore = NotificationStores();

const moveToHome = (uuid) => {
  xhr.addRequestToQueue("POST", `/imprimantes/move/home/${uuid}`, null, true, true, false,
      (response) => {
        if (response.code !== 200) {
          if (response.code === 0 || !jsonValidator.validate(response.response)) {
            notificationStore.addNotification(
                t("errorDuringGoToHome"),
                "error");
          } else {
            notificationStore.addNotification(
                JSON.parse(response.response).message,
                "error");
          }
        } else {
          notificationStore.addNotification(
              t("goToHomeSuccess"),
              "success");
        }
      });
}

</script>

<style scoped>

</style>